import { gql } from "@apollo/client";

export const CAROUSEL_BANNERS_QUERY = gql`
  query CarouselBanners($channel: String, $platform: CMSPlatform, $device: CMSDeviceType, $isPublished: Boolean) {
    carouselBanners(channel: $channel, platform: $platform, device: $device, isPublished: $isPublished) {
      id
      title
      subtitle
      description
      imageUrl
      altText
      redirectType
      redirectValue
      targetPlatform
      targetDevice
      sortOrder
      isPublished
      publishedAt
      createdAt
    }
  }
`;

export const SHORT_VIDEOS_QUERY = gql`
  query ShortVideos($channel: String, $platform: CMSPlatform, $device: CMSDeviceType, $isPublished: Boolean) {
    shortVideos(channel: $channel, platform: $platform, device: $device, isPublished: $isPublished) {
      id
      title
      subtitle
      description
      videoUrl
      thumbnailUrl
      altText
      durationSeconds
      redirectType
      redirectValue
      targetPlatform
      targetDevice
      sortOrder
      isPublished
      publishedAt
      createdAt
    }
  }
`;

export const CMS_DELIVERY_SLOTS_QUERY = gql`
  query CMSDeliverySlots($isActive: Boolean) {
    cmsDeliverySlots(isActive: $isActive) {
      id
      slotKey
      label
      timeWindow
      dayOffset
      skipWeekday
      useNextSat
      cutoffTime
      sortOrder
      isActive
      productTypes {
        id
        name
      }
    }
  }
`;

export const CMS_DELIVERY_VACATIONS_QUERY = gql`
  query CMSDeliveryVacations($dateFrom: Date, $dateTo: Date, $isActive: Boolean) {
    cmsDeliveryVacations(dateFrom: $dateFrom, dateTo: $dateTo, isActive: $isActive) {
      id
      date
      label
      isActive
      deliverySlots {
        id
        slotKey
        label
      }
      productTypes {
        id
        name
      }
    }
  }
`;

export const SEASONAL_PICKS_QUERY = gql`
  query SeasonalPicks($season: SeasonType, $isPublished: Boolean) {
    seasonalPicks(season: $season, isPublished: $isPublished) {
      id
      label
      slug
      imageUrl
      farmerName
      farmLocation
      tagline
      season
      sortOrder
      isPublished
    }
  }
`;

export const DELIVERY_LOCATIONS_QUERY = gql`
  query DeliveryLocations($city: String, $isActive: Boolean) {
    deliveryLocations(city: $city, isActive: $isActive) {
      id
      locationKey
      name
      area
      city
      state
      pincode
      fullAddress
      isActive
      isServiceable
      minimumOrderValue
      deliveryFee
      freeDeliveryAbove
      sortOrder
    }
  }
`;

export const PRODUCT_TYPES_LIST_QUERY = gql`
  query ProductTypesListForCms {
    productTypes(first: 100) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const CMS_DELIVERY_DATE_PREVIEW_QUERY = gql`
  query CMSDeliveryDatePreview($slotKey: String!, $orderDatetime: DateTime) {
    cmsDeliveryDatePreview(slotKey: $slotKey, orderDatetime: $orderDatetime)
  }
`;

